import * as React from 'react';
import { styled } from '@mui/material/styles';
import MuiButton from '@mui/material/Button';

/**
 * サイト共通ボタン。
 * tone: 'green'（既定・緑ベタ） / 'ghost'（暗い背景の上の白枠） / 'light'（緑背景の上の白ベタ）
 * size: 'small' / 'medium'（既定） / 'large'
 */
const ButtonRoot = styled(MuiButton, {
  shouldForwardProp: (prop) => prop !== 'tone',
})(({ theme, size, tone = 'green' }) => ({
  borderRadius: 0,
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  fontSize: 15,
  letterSpacing: '.08em',
  lineHeight: 1.6,
  padding: '16px 36px',
  gap: 12,
  boxShadow: 'none',
  textTransform: 'none',
  minWidth: 0,
  transition: 'background-color .25s, color .25s, border-color .25s',
  '&:hover, &:active, &:focus': {
    boxShadow: 'none',
  },
  ...(tone === 'green' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': { backgroundColor: theme.palette.primary.dark },
  }),
  ...(tone === 'ghost' && {
    backgroundColor: 'transparent',
    border: '1px solid rgba(255,255,255,.7)',
    color: '#ffffff',
    '&:hover': { backgroundColor: 'rgba(255,255,255,.12)' },
  }),
  ...(tone === 'light' && {
    backgroundColor: '#ffffff',
    color: theme.palette.primary.main,
    '&:hover': { backgroundColor: theme.palette.kinari },
  }),
  ...(size === 'small' && {
    padding: '12px 24px',
    fontSize: 14,
  }),
  ...(size === 'large' && {
    padding: '18px 44px',
    fontSize: 16,
  }),
  [theme.breakpoints.down('sm')]: {
    ...(size === 'small' && { padding: '10px 16px', fontSize: 13 }),
  },
}));

function Button(props) {
  return <ButtonRoot disableElevation disableRipple={false} {...props} />;
}

export default Button;
